import angular from 'angular';
import insuranceCreateApplication from './insuranceCreateApplication';
import './style.scss';

export default angular
  .module('components.insuranceCreateApplication', [])
  .component('insuranceCreateApplication', insuranceCreateApplication).name;
